module.exports = __webpack_public_path__ + "img/blueSapphire@2x.3e1abd2.jpg";